export const AdminInquiryConst = {
  FETCH_ALL_REQUEST: "SA_FETCH_ALL_INQUIRIES_REQUEST",
  FETCH_ALL_SUCCESS: "SA_FETCH_ALL_INQUIRIES_SUCCESS",
  FETCH_ALL_FAIL: "SA_FETCH_ALL_INQUIRIES_FAIL",

  FETCH_MESSAGES_REQUEST: "SA_FETCH_INQUIRY_MESSAGES_REQUEST",
  FETCH_MESSAGES_SUCCESS: "SA_FETCH_INQUIRY_MESSAGES_SUCCESS",
  FETCH_MESSAGES_FAIL: "SA_FETCH_INQUIRY_MESSAGES_FAIL",

  SEND_MESSAGE_REQUEST: "SA_SEND_INQUIRY_MESSAGE_REQUEST",
  SEND_MESSAGE_SUCCESS: "SA_SEND_INQUIRY_MESSAGE_SUCCESS",
  SEND_MESSAGE_FAIL: "SA_SEND_INQUIRY_MESSAGE_FAIL",

  UPDATE_STATUS_REQUEST: "SA_UPDATE_INQUIRY_STATUS_REQUEST",
  UPDATE_STATUS_SUCCESS: "SA_UPDATE_INQUIRY_STATUS_SUCCESS",
  UPDATE_STATUS_FAIL: "SA_UPDATE_INQUIRY_STATUS_FAIL",

  CLEAR_ACTION: "SA_ADMIN_INQUIRY_CLEAR_ACTION",
};
